import { BrowserRouter, Route, Routes } from 'react-router';
import Modal from 'react-modal';
import Questionnaire from './Questionnaire';
import Results from './Results';
import Refinement from './Refinement';
import Offer from './Offer';
import ThankYou from './ThankYou';

export default function Heatpump() {
    Modal.setAppElement('#root');

    return (
        <BrowserRouter>
            <Routes>
                <Route path=":locale/" element={<Questionnaire />} />
                <Route path=":locale/results" element={<Results />} />
                <Route path=":locale/refinement" element={<Refinement />} />
                <Route path=":locale/offer/thankyou" element={<ThankYou />} />
                <Route path=":locale/offer/:id" element={<Offer />} />
                <Route path="" element={<Questionnaire />} />
                <Route path="results" element={<Results />} />
                <Route path="refinement" element={<Refinement />} />
                <Route path="offer/thankyou" element={<ThankYou />} />
                <Route path="offer/:id" element={<Offer />} />
            </Routes>
        </BrowserRouter>
    );
}
